import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "button__content" }
const _hoisted_2 = {
  key: 0,
  class: "button__icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["button", [
      `button--${$props.skin}`,
      `button--${$props.size}`,
      $props.isDisabled && 'button--disabled',
      $props.isWide && 'button--wide',
      $props.isIcon && 'button--icon',
    ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      ($props.isIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 2))
}